import { ChangeDetectionStrategy, Component, inject, Injector, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { ScreenRecorderService } from './screen-recorder.service';
import { RecordingIndicatorComponent } from '../audio-recorder/recording-indicator/recording-indicator.component';

@Component({
  selector: 'app-screen-recorder-floating-controls',
  standalone: true,
  imports: [MatButtonModule, MatIconModule, TranslateModule, RecordingIndicatorComponent],
  template: `
    @if (screenRecorderService.isCountingDown()) {
      <div class="flex items-center gap-3 bg-white border border-[var(--skz-border-color-main,rgba(226,232,240,0.8))] px-4 py-2.5 rounded-full shadow-lg animate-fade-in-up">
        <div class="flex items-center gap-2">
          <span class="flex h-3 w-3 relative">
            <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
            <span class="relative inline-flex rounded-full h-3 w-3 bg-blue-500"></span>
          </span>
          <span class="text-[var(--skz-text-primary,#2d3748)] text-sm font-bold tracking-wide">
            {{ 'ScreenRecorder.StartingIn' | translate }} {{ screenRecorderService.countdown() }}...
          </span>
        </div>
      </div>
    } @else {
      <div class="flex items-center gap-4 bg-white border border-[var(--skz-border-color-main,rgba(226,232,240,0.8))] px-4 py-2.5 rounded-full shadow-lg animate-fade-in-up">
        <div class="flex items-center gap-2">
          <span class="flex h-3 w-3 relative">
            <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
            <span class="relative inline-flex rounded-full h-3 w-3 bg-red-500"></span>
          </span>
          <span class="text-[var(--skz-text-primary,#2d3748)] text-sm font-semibold tracking-wide">
            {{ 'ScreenRecorder.Recording' | translate }}
          </span>
        </div>
        <div class="h-4 w-[1px] bg-[var(--skz-border-color-main,rgba(226,232,240,0.8))]"></div>
        <app-recording-indicator
          [stream]="screenRecorderService.stream()"
          [icon]="'stop'"
          [variant]="'danger'"
          (stopClick)="stop()"
          [title]="'ScreenRecorder.Stop' | translate"
        ></app-recording-indicator>
      </div>
    }
  `,
  styles: [
    `
      @keyframes fadeInUp {
        from {
          opacity: 0;
          transform: translateY(10px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
      .animate-fade-in-up {
        animation: fadeInUp 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScreenRecorderFloatingControlsComponent implements OnInit {
  private injector = inject(Injector);
  public screenRecorderService!: ScreenRecorderService;

  ngOnInit(): void {
    // Inject ScreenRecorderService dynamically to prevent circular dependencies
    this.screenRecorderService = this.injector.get(ScreenRecorderService);
  }

  stop(): void {
    this.screenRecorderService.stopRecording();
  }
}
